import posthog from 'posthog-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Helmet, HelmetProvider } from 'react-helmet-async'

import { App } from './App'
import './index.css'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

// prod key:
const posthog_key = 'phc_8Om0lBpHx9Z3F2kDw4bJ0A800yubBMbImZ9wrFe5fb2'

posthog.init(posthog_key, {
  api_host: 'https://us.posthog.com',
  autocapture: true,
  capture_pageview: true,
})

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Helmet>
        <title>Scrubstr</title>
        <meta property="og:title" content="Scrubstr" />
        <meta property="og:image" content="/assets/hospital-header.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()
